export const GALLERY = [
  {
    image: '/assets/intro/puzzleScreen.png',
    tag: 'logic',
    tagColor: 'tagGreen',
    title: 'puzzles',
    desc: 'puzzles_description',
  },
  {
    image: '/assets/intro/paintingScreen.png',
    tag: 'creativity',
    tagColor: 'tagTeal',
    title: 'painting',
    desc: 'kids_canvas_description',
  },
];
